import { useState, useEffect } from "react";
import { useSelector, useDispatch } from "react-redux";
import { useLocation, useNavigate } from "react-router-dom";
import { message } from "antd";

import { OthersAction } from "../../store/actions";

import { Spacer, inputFields, university, Buttons } from "../../components";

const EditCountry = () => {
  const location = useLocation();
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const id = location.pathname.split("/")[3];

  const { continents, regions, countries } = useSelector(
    (state) => state?.others
  );

  const [state, setState] = useState({
    name: "",
    countryCode: "",
    continentID: "",
    regionsID: "",
  });

  useEffect(() => {
    countries?.map((country) => {
      if (country.id === parseInt(id)) {
        setState({
          name: country?.name ?? null,
          countryCode: country?.countryCode ?? null,
          continentID: country?.continentID ?? null,
          regionsID: country?.regionsID ?? null,
        });
      }
    });
  }, [id, countries]);

  const handleSubmit = () => {
    if (!state.name || !state.continentID) {
      message.error("Please fill all the required fields");
      return;
    } else {
      const payload = { id: parseInt(id), ...state };

      dispatch(
        OthersAction.editCountry(payload, (res) => {
          dispatch(OthersAction.getCountries());
          if (res.status === 200) {
            navigate("/country");
          }
        })
      );
    }
  };

  return (
    <div className="text-black">
      <div className="grid grid-cols-2 gap-5">
        <div className="flex flex-col gap-3">
          <university.UniInputLabel title="Name" required />
          <inputFields.DefaultInput
            onChange={(e) => setState({ ...state, name: e.target.value })}
            value={state?.name}
          />
        </div>
        <div className="flex flex-col gap-3">
          <university.UniInputLabel title="Country Code" />
          <inputFields.DefaultInput
            onChange={(e) =>
              setState({ ...state, countryCode: e.target.value })
            }
            value={state?.countryCode}
          />
        </div>
        <div className="flex flex-col gap-3">
          <university.UniInputLabel title="Continent" required />
          <inputFields.SelectDropdown
            items={continents?.map((continent) => ({
              label: continent.name,
              value: continent.id,
            }))}
            onChange={(e) => setState({ ...state, continentID: e })}
            value={state?.continentID}
          />
        </div>
        <div className="flex flex-col gap-3">
          <university.UniInputLabel title="Region" />
          <inputFields.SelectDropdown
            items={regions?.map((region) => ({
              label: region.name,
              value: region.id,
            }))}
            onChange={(e) => setState({ ...state, regionsID: e })}
            value={state?.regionsID}
          />
        </div>
      </div>
      <Spacer height={20} />
      <div className="flex w-full justify-end">
        <Buttons.DefaultButton onClick={handleSubmit}>
          Submit
        </Buttons.DefaultButton>
      </div>
    </div>
  );
};

export default EditCountry;
